import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopandharpurcab() {



  const cardData =
  {
    keyword: ' Pune to Pandharpur Cab',
    heading: 'Sai Trupti Cabs: Pune to Pandharpur Cab',
    headingDescription: 'Sai Trupti Cabs offers dependable and comfortable Pune to Pandharpur cab services, ideal for devotional trips, family outings, or group travel. Our air-conditioned fleet of Sedans, SUVs and spacious vehicles ensures a smooth ride (approx. 210 km) to the holy town. Experienced and background-verified chauffeurs guarantee punctual pickups, courteous service and safe driving throughout the journey. With transparent one-way pricing, flexible booking options and 24×7 customer support, we make your trip from Pune to Pandharpur seamless, stress-free and memorable.',

    top: 'Top Places to Visit in Pandharpur with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Vitthal Rukmini Temple",
    "description": "The Vitthal Rukmini Temple is the spiritual soul of Pandharpur and one of Maharashtra’s most sacred pilgrimage sites. Dedicated to Lord Vitthal (a form of Lord Krishna) and Goddess Rukmini, the temple attracts millions of devotees, especially during the Ashadhi and Kartiki Ekadashi yatras. Pilgrims chant ‘Vithoba Vithoba’ as they queue for darshan of the beautiful black stone idol standing on a brick. The temple’s divine atmosphere, rhythmic bhajans, and ancient carvings reflect centuries of unbroken devotion and faith."
  },
  {
    "title": "Chandrabhaga River (Bhima River)",
    "description": "Flowing gracefully beside the temple, the Chandrabhaga River — also known as the Bhima — is considered holy by devotees. Pilgrims take a sacred dip in its waters before visiting the Vitthal Temple, believing it purifies the soul and washes away sins. The river forms a crescent shape resembling the moon, giving it its name 'Chandrabhaga'. Early mornings here are filled with the sound of bells, chants, and the gentle lapping of holy waters that bless every visitor with peace and purity."
  },
  {
    "title": "Pundalik Temple",
    "description": "The Pundalik Temple holds deep mythological significance, dedicated to the saint Pundalik — whose devotion brought Lord Vitthal to Pandharpur. It is believed that when Vitthal appeared at Pundalik’s doorstep, he stood on a brick waiting for his devotee, giving rise to the famous pose of Lord Vithoba. The temple’s simple architecture and spiritual aura remind visitors that sincere devotion and service to parents are the highest forms of worship. It stands as a monument to selfless love and divine humility."
  },
  {
    "title": "ISKCON Pandharpur",
    "description": "ISKCON Pandharpur, also known as the Sri Sri Radha Pandharinath Temple, blends traditional devotion with modern spiritual culture. Managed by the International Society for Krishna Consciousness, the temple offers vibrant kirtans, serene gardens, and educational programs on the Bhagavad Gita. Its calm atmosphere and divine chants attract both Indian and international devotees. The beautifully adorned idols of Lord Krishna and Radha reflect timeless love and spirituality, making it a peaceful retreat from worldly distractions."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "Kaikadi Maharaj Math is a fascinating spiritual ashram that combines devotion with creativity. Its underground caves are decorated with vivid sculptures and murals depicting scenes from Indian mythology and the life of saints. The Math showcases the rich cultural and religious heritage of Maharashtra through visual storytelling. Visitors are often mesmerized by the artistic detail and devotion behind each display. It’s a must-visit site that brings faith and art together in a truly unique way."
  },
  {
    "title": "Tulsi Vrindavan Mandir",
    "description": "Tulsi Vrindavan Mandir is a serene shrine dedicated to the sacred Tulsi plant, symbolizing purity and devotion. Devotees gather here to offer prayers and circumambulate the holy basil, which is deeply associated with Lord Vishnu. The gentle aroma of incense, ringing bells, and chanting create an atmosphere of deep tranquility. Visiting this temple fills one’s heart with calmness and reverence, reminding pilgrims of the intimate connection between nature and divinity in Hindu worship."
  },
  {
    "title": "Sant Namdev Maharaj Samadhi Mandir",
    "description": "The Samadhi of Sant Namdev Maharaj is a revered site honoring one of the most beloved saints of the Bhakti movement. Known for his devotional abhangs and unconditional faith in Lord Vitthal, Namdev’s teachings continue to inspire millions. The temple radiates simplicity, humility, and divine grace. Pilgrims visit this place to pay homage to the saint whose words and life brought the common man closer to God. The calm ambiance invites quiet reflection and heartfelt prayer."
  },
  {
    "title": "Sant Chokhamela Samadhi Mandir",
    "description": "Sant Chokhamela Samadhi Mandir commemorates the life of the great devotee Chokhamela, who transcended caste barriers through his unshakable devotion to Lord Vitthal. His songs and poems are timeless expressions of faith and equality. The temple stands as a powerful reminder that true spirituality lies in the purity of the heart, not in social status. Devotees visiting this sacred spot experience profound inspiration from Chokhamela’s life of humility, love, and devotion."
  },
  {
    "title": "Vithoba Ghat",
    "description": "Vithoba Ghat along the Chandrabhaga River serves as a central gathering point for pilgrims during major yatras and rituals. The steps leading to the river are filled with devotees performing aarti, lighting diyas, and chanting in unison. As the sun sets, the reflection of the temple lights on the river creates a mesmerizing view. The ghat beautifully captures the spiritual rhythm of Pandharpur — a place where devotion flows endlessly like the river itself."
  },
  {
    "title": "Sant Tukaram Maharaj Mandir",
    "description": "Sant Tukaram Maharaj Mandir celebrates the legacy of one of Maharashtra’s most revered saints and poets of the Bhakti era. Though based in Dehu, Tukaram’s spirit is deeply connected to Pandharpur through his abhangs praising Lord Vitthal. The temple honors his divine compositions and teachings of equality, love, and devotion. Visiting this shrine completes the spiritual circuit for pilgrims, connecting the sacred bond between saints, devotees, and their beloved Lord Vitthal."
  }
],



"services": [
    {
      "name": "Pune to Pandharpur Cab",
      "description": "Reliable cab service from Pune to Pandharpur offering comfortable rides, professional drivers, and hassle-free travel for pilgrims, families, and groups visiting Pandharpur."
    },
    {
      "name": "Pune to Pandharpur Taxi",
      "description": "Convenient taxi service from Pune to Pandharpur with AC and non-AC options, one-way and round trips, ensuring safe, timely, and comfortable travel."
    },
    {
      "name": "Pune to Pandharpur Car Hire",
      "description": "Car hire service from Pune to Pandharpur with a range of vehicles including Sedans, SUVs, and luxury cars for personalized travel and long-distance comfort."
    },
    {
      "name": "Pune to Pandharpur Innova Cab",
      "description": "Travel from Pune to Pandharpur in a spacious Innova cab, ideal for families or small groups, with AC service and professional drivers ensuring a smooth journey."
    },
    {
      "name": "Pune to Pandharpur Ertiga Cab",
      "description": "Ertiga cab service from Pune to Pandharpur providing comfortable seating for groups, AC service, and reliable, safe transport for your pilgrimage or trip."
    },
    {
      "name": "Pune to Pandharpur Sedan Cab",
      "description": "Sedan cab service from Pune to Pandharpur offering a smooth, comfortable ride with professional drivers and optional luxury amenities for stress-free travel."
    },
    {
      "name": "Pune to Pandharpur One Way Taxi",
      "description": "Affordable one-way taxi service from Pune to Pandharpur, ideal for travelers seeking direct and efficient transport without waiting or delays."
    },
    {
      "name": "Pune to Pandharpur Drop Cab",
      "description": "Drop cab service from Pune to Pandharpur providing point-to-point travel with AC cars, professional drivers, and reliable service for a convenient journey."
    },
    {
      "name": "Pune to Pandharpur Luxury Cab",
      "description": "Premium luxury cab service from Pune to Pandharpur with top-class vehicles, AC service, and professional chauffeurs ensuring a comfortable and high-end travel experience."
    },
    {
      "name": "Pune to Pandharpur Outstation Cab",
      "description": "Outstation cab service from Pune to Pandharpur including long-distance travel comforts, tolls, driver allowances, and a variety of vehicle options for all budgets."
    },
    {
      "name": "Affordable Pune to Pandharpur Cab",
      "description": "Budget-friendly cab service from Pune to Pandharpur offering comfortable AC vehicles, reliable drivers, and transparent fare options for cost-effective travel."
    },
    {
      "name": "Pune to Pandharpur AC Cab",
      "description": "AC cab service from Pune to Pandharpur providing cool and comfortable rides, professional drivers, and safe travel for families, groups, and solo travelers."
    },
    {
      "name": "Pune to Pandharpur Online Booking",
      "description": "Book your Pune to Pandharpur cab online instantly with multiple vehicle options, secure payments, and transparent fares for a stress-free travel experience."
    },
    {
      "name": "Pune to Pandharpur Travel Service",
      "description": "Comprehensive travel service from Pune to Pandharpur including cabs, drop services, luxury options, and professional drivers for a smooth and enjoyable journey."
    },
    {
      "name": "Pune to Pandharpur Cab near Me",
      "description": "Find Pune to Pandharpur cabs near your location for quick and convenient booking, with reliable drivers, AC and luxury options, and hassle-free service."
    }
  ],
  "tableData": [
    ["Pune to Pandharpur Cab", "Pune to Pandharpur Taxi"],
    ["Pune to Pandharpur Car Hire", "Pune to Pandharpur Innova Cab"],
    ["Pune to Pandharpur Ertiga Cab", "Pune to Pandharpur Sedan Cab"],
    ["Pune to Pandharpur One Way Taxi", "Pune to Pandharpur Drop Cab"],
    ["Pune to Pandharpur Luxury Cab", "Pune to Pandharpur Outstation Cab"],
    ["Affordable Pune to Pandharpur Cab", "Pune to Pandharpur AC Cab"],
    ["Pune to Pandharpur Online Booking", "Pune to Pandharpur Travel Service"],
    ["Pune to Pandharpur Cab near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Pandharpur Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable cab services from Pune to Pandharpur — ideal for pilgrimage, family travel or a scenic road trip."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one‑way fares from Pune to Pandharpur start from approx. ₹2,849 to ₹3,163 depending on car type and distance. :contentReference[oaicite:1]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort for the Pune to Pandharpur journey. :contentReference[oaicite:2]{index=2}"
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers are familiar with the Pune‑to‑Pandharpur route, ensuring a safe, smooth and timely experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups anywhere in Pune and drop‑offs in Pandharpur (including temple vicinity, station or city‑centre)."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized and equipped to ensure comfort and reliability for your drive to Pandharpur."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available around the clock to assist with bookings, route planning or any travel changes for your Pune‑to‑Pandharpur cab."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Pandharpur cab easily via call, WhatsApp or our website — with instant confirmation and prompt vehicle dispatch."
  }
]





































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Pandharpur cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable cab services from Pune to Pandharpur for one way, round trip, and group travel.',
  },
  {
    question: 'How can I book a cab from Pune to Pandharpur with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Pandharpur cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Pandharpur?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Pandharpur trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Pandharpur for family or group trips?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and religious travel from Pune to Pandharpur.',
  },
  {
    question: 'Is the Pune to Pandharpur cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pune to Pandharpur for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Pandharpur cab fares?',
    answer: 'Our cab fares start from ₹2,000 for sedans, ₹2,500–₹3,500 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Pandharpur cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Pandharpur cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Pandharpur cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Pandharpur cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Patil',
    feedback: 'I booked a Pune to Pandharpur cab with Sai Trupti Cabs. The journey was comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priyanka Kulkarni',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Pandharpur trip. Smooth journey and punctual driver.',
    rating: 5,
  },
];
































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pandharpur Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Pune to Pandharpur Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-pandharpur-cab"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune to Pandharpur Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Pandharpur Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to Pandharpur Cab, Pune to Pandharpur Taxi, Pune to Pandharpur Car Hire, Pune to Pandharpur Innova Cab, Pune to Pandharpur Ertiga Cab, Pune to Pandharpur Sedan Cab, Pune to Pandharpur One Way Taxi, Pune to Pandharpur Drop Cab, Pune to Pandharpur Luxury Cab, Pune to Pandharpur Outstation Cab, Affordable Pune to Pandharpur Cab, Pune to Pandharpur AC Cab, Pune to Pandharpur Online Booking, Pune to Pandharpur Travel Service, Pune to Pandharpur Cab near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopandharpurcab;